// @ts-strict-ignore
import { useRouteMatch } from 'react-router-dom';

import { useParseOverlayQueryParams } from '@/components/AppOverlay';
import type { PreviewParamsType } from '@/components/Preview/OverlayPreview/constants';
import { useResponsiveConstants } from '@/hooks/responsive/useResponsiveConstants';

export const useIsOverlayPreview = () => {
  const overlayParams = useParseOverlayQueryParams() as PreviewParamsType;

  const isFullPreview = useRouteMatch('/preview');

  const { mobile } = useResponsiveConstants();

  return (
    !isFullPreview &&
    !!overlayParams &&
    Object.keys(overlayParams).length > 0 &&
    !mobile
  );
};
